import { APP_VERSION, APP_ID } from "../constants/env-resolver";
import debug from "../debug";
import fnBrowserDetect from "./data-lake/browser-detect";
import withLoginDatalake from "./data-lake/with-login-datalake";
import withoutLoginDatalake from "./data-lake/without-login-datalake";
import { encrypt } from "../secure";
import { v4 as uuidv4 } from "uuid";

/**
 * Check if a customerId is null, undefined, or an empty string.
 *
 * @param {string | null | undefined} customerId - The customerId to check.
 * @returns {boolean} - True if customerId is null, undefined, or an empty string, otherwise false.
 */
const isCustomerIdNullOrEmpty = customerId => {
  return customerId === null || customerId === undefined || customerId === "";
};

/**
 * Concatenates the origin and pathname strings from the window.location object
 * and slices the first 40 characters.
 *
 * @returns {string} - The screen name, which is the first 40 characters of the concatenated string.
 */
const getScreenName = () => {
  const origin = window.location.origin;
  const pathname = window.location.pathname;

  const concatenatedString = origin + pathname;
  return concatenatedString.slice(0, 40);
};

/**
 * Tracker used to track data lake events, mainly involving API calls errors as well as file reader errors
 * @param {string} logEventType - Type of event to be tracked can be [`error`,`event`,`exception`,`device_info`]
 * @param {string} eventName - All caps event name like `API_CALL_ERROR` or `FILE_READER_ERROR`
 * @param {string} eventValue - Event value to be tracked
 * @param {string} customerId - 3.0 customer id
 * @param {string} customerRefNum - 3.0 customer ref num
 * @param {string} Authorization - 3.0 Authorization
 * @param {Array|string} apiName - API name or array of folder names for tracking
 */
const DataLakeTracker = ({
  logEventType = "event",
  eventName = "_",
  eventValue = "_",
  customerId = null,
  customerRefNum = null,
  Authorization = null,
  apiName = null,
  isEncrypted = false,
  segment = "NEW_QR",
  successFn = res => {
    debug("WATCH", `Response: `, res);
  },
  errorFn = err => {
    debug("ERROR", `Error: `, err);
  },
  finallyFn = () => {
    debug("WATCH", `Finally: `);
  },
}) => {
  const isAuthenticatedUser = !isCustomerIdNullOrEmpty(customerId)
    ? true
    : false;
  const errorExceptionData = {
    logEventType,
    source: "NEW_QR",
    deviceModel: window.navigator.userAgent,
    browser: fnBrowserDetect(),
    browserVersion: navigator.appVersion,
    eventName,
    screenName: getScreenName(),
    errorMessage: eventValue,
    segment,
    apiName,
  };
  function getCookie(name) {
    let cookieArray = document.cookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split("=");
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
  const eventData = {
    logEventType,
    source: "NEW_QR",
    deviceModel: window.navigator.userAgent,
    browser: fnBrowserDetect(),
    browserVersion: navigator.appVersion,
    eventName,
    screenName: getScreenName(),
    eventValue: eventValue,
    segment,
    apiName,
  };
  // let deviceId = window.sessionStorage.getItem('deviceId');
  let deviceId;
  let existingCookieValue = getCookie("browserId");
  if (
    existingCookieValue !== null &&
    existingCookieValue !== undefined &&
    existingCookieValue !== ""
  ) {
    // Cookie with the specified name already exists and has a non-empty value
    deviceId = existingCookieValue;
  }
  const dataLakeEventPayload = {
    errorExceptionData:
      logEventType === "event" || logEventType === "device_info"
        ? eventData
        : errorExceptionData,
    customerRefNum: customerRefNum,
    deviceId: deviceId,
    appId: APP_ID,
    appVersion: APP_VERSION,
  };

  let APIPayloadToPost = {};
  APIPayloadToPost["appId"] = APP_ID;
  APIPayloadToPost["appVersion"] = APP_VERSION;
  APIPayloadToPost["requestId"] = uuidv4();

  console.log("APIPayloadToPost Before Data: ", APIPayloadToPost);

  if (isAuthenticatedUser) {
    dataLakeEventPayload.customerRefNum = customerRefNum;
    APIPayloadToPost["data"] = encrypt(customerId, dataLakeEventPayload);
    withLoginDatalake({
      customerId,
      APIPayloadToPost,
      Authorization,
      successFn,
      errorFn,
      finallyFn,
    });
  } else {
    APIPayloadToPost["data"] = encrypt(null, dataLakeEventPayload);
    withoutLoginDatalake({
      APIPayloadToPost,
      successFn,
      errorFn,
      finallyFn,
    });
  }
};
export default DataLakeTracker;
